import { useCallback, useContext } from 'react';

import { CustomerInfoProviderContext, CustomerInfoType } from './index';

export const useCachedCustomerInfo = () => {
	const { state, setState } = useContext(CustomerInfoProviderContext);

	const setCachedCustomerInfo = useCallback(
		(info: CustomerInfoType) => {
			setState(info);
		},
		[setState]
	);

	const updateCachedCustomerInfo = useCallback(
		(info: CustomerInfoType) => {
			setState({ ...state, ...info });
		},
		[state, setState]
	);

	return {
		cachedCustomerInfo: state,
		setCachedCustomerInfo,
		updateCachedCustomerInfo,
	};
};
